const topList = [
  "bestProvider",
  "expertDevelopers",
  "innovativeServices",
  "highPerformanceApps",
  "scalableDevelopment"
]

const typesOfMobileApps = [
  "nativePlatforms",
  "crossPlatforms",
  "hybridModels",
  "progressiveWebApp"
]

const keyResponsibilities = [
  "gatherRequirements",
  "designUIUX",
  "writeCode",
  "integrateSystems",
  "testDebug",
  "deployApps",
]

const features = [
  {
    icon: '😊',
    title: 'feature_clientCentric_title',
    description: 'feature_clientCentric_description',
  },
  {
    icon: '⚡',
    title: 'feature_acceleratedDevelopment_title',
    description: 'feature_acceleratedDevelopment_description',
  },
  {
    icon: '🎯',
    title: 'feature_strategicDesign_title',
    description: 'feature_strategicDesign_description',
  },
  {
    icon: '📈',
    title: 'feature_performancePayoff_title',
    description: 'feature_performancePayoff_description',
  },
  {
    icon: '🧩',
    title: 'feature_simplifiedUX_title',
    description: 'feature_simplifiedUX_description',
  },
  {
    icon: '🤝',
    title: 'feature_skilledTeam_title',
    description: 'feature_skilledTeam_description',
  },
];

export {
  topList,
  keyResponsibilities,
  typesOfMobileApps,
  features
}
